/**
 * @generated SignedSource<<159dad237ad111e85e2d5cce6c578ee7>>
 * @relayHash 8509e4b8ffa66998b1d08c152618ae78
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 540885f364a3745c4c08cea2f25690339508226d482007bccb96f1ee8619d37a

import type { ConcreteRequest } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type fetchIssueDescriptionSmartlinkDataQuery$variables = {
  after: string;
  cloudId: string;
  first: number;
  issueKey: string;
  useFasterFields: boolean;
};
export type fetchIssueDescriptionSmartlinkDataQuery$data = {
  readonly jira: {
    readonly issueByKey: {
      readonly description?: {
        readonly adfValue: {
          readonly smartLinks: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly url: string | null;
              } | null;
            } | null> | null;
          } | null;
        } | null;
      } | null;
      readonly descriptionField?: {
        readonly richText: {
          readonly adfValue: {
            readonly smartLinks: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly url: string | null;
                } | null;
              } | null> | null;
            } | null;
          } | null;
        } | null;
      } | null;
      readonly project?: {
        readonly projectType: JiraProjectType | null;
      } | null;
      readonly projectField?: {
        readonly project: {
          readonly projectType: JiraProjectType | null;
        } | null;
      } | null;
    } | null;
  } | null;
};
export type fetchIssueDescriptionSmartlinkDataQuery = {
  response: fetchIssueDescriptionSmartlinkDataQuery$data;
  variables: fetchIssueDescriptionSmartlinkDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueKey"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "useFasterFields"
},
v5 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "issueKey"
  }
],
v6 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "url"
},
v8 = [
  {
    "concreteType": "JiraADF",
    "kind": "LinkedField",
    "name": "adfValue",
    "plural": false,
    "selections": [
      {
        "args": (v6/*: any*/),
        "concreteType": "JiraSmartLinkConnection",
        "kind": "LinkedField",
        "name": "smartLinks",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraSmartLinkEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v7/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "projectType"
},
v10 = {
  "concreteType": "JiraProject",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v9/*: any*/)
  ]
},
v11 = [
  {
    "concreteType": "JiraADF",
    "kind": "LinkedField",
    "name": "adfValue",
    "plural": false,
    "selections": [
      {
        "args": (v6/*: any*/),
        "concreteType": "JiraSmartLinkConnection",
        "kind": "LinkedField",
        "name": "smartLinks",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraSmartLinkEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v7/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  }
],
v12 = {
  "kind": "ScalarField",
  "name": "id"
},
v13 = {
  "concreteType": "JiraProject",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v12/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "fetchIssueDescriptionSmartlinkDataQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
              {
                "condition": "useFasterFields",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "concreteType": "JiraRichTextField",
                    "kind": "LinkedField",
                    "name": "descriptionField",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraRichText",
                        "kind": "LinkedField",
                        "name": "richText",
                        "plural": false,
                        "selections": (v8/*: any*/)
                      }
                    ]
                  },
                  {
                    "concreteType": "JiraProjectField",
                    "kind": "LinkedField",
                    "name": "projectField",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/)
                    ]
                  }
                ]
              },
              {
                "condition": "useFasterFields",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "JiraRichText",
                    "kind": "LinkedField",
                    "name": "description",
                    "plural": false,
                    "selections": (v8/*: any*/)
                  },
                  (v10/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "fetchIssueDescriptionSmartlinkDataQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
              {
                "condition": "useFasterFields",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "concreteType": "JiraRichTextField",
                    "kind": "LinkedField",
                    "name": "descriptionField",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraRichText",
                        "kind": "LinkedField",
                        "name": "richText",
                        "plural": false,
                        "selections": (v11/*: any*/)
                      },
                      (v12/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "JiraProjectField",
                    "kind": "LinkedField",
                    "name": "projectField",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v12/*: any*/)
                    ]
                  }
                ]
              },
              {
                "condition": "useFasterFields",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "JiraRichText",
                    "kind": "LinkedField",
                    "name": "description",
                    "plural": false,
                    "selections": (v11/*: any*/)
                  },
                  (v13/*: any*/)
                ]
              },
              (v12/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "540885f364a3745c4c08cea2f25690339508226d482007bccb96f1ee8619d37a",
    "metadata": {},
    "name": "fetchIssueDescriptionSmartlinkDataQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "26ad8f9f656283cf1787ab6aae86abed";

export default node;
